import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import Cookies from 'js-cookie';
import { SOCIAL_PLATFORMS } from '@Components/Common/Constents';

const MonthYear = ({ start, end, name, type, label, validate, methods }) => {
    return (
        <>
            <label htmlFor={name}>{label}</label>
            <select name={name} defaultValue="" ref={methods?.register(validate)} className="form-control">
                <option value="" disabled={true}>{type}</option>
                {(() => {
                    const options = [];
                    for (let i = start; i <= end; i++) {
                        options.push(i)
                    }
                    return options?.map((value) => <option value={value} key={value}>{value}</option>)
                })()}
            </select>
            {methods?.errors?.[name] && <span className="error">{methods?.errors?.[name]?.message}</span>}
        </>
    );
};

function WithoutLoginCard({ isAutoship, logintoken, socialPlatformsValue, setOtherFieldData }) {
    const [redirectID, setRedirectID] = useState();
    const [checked, setChecked] = useState(true);
    const [userLogin, setUserLogin] = useState();
    const [creditCardError, setCreditCardError] = useState(false);
    const methods = useFormContext();
    const currentYear = new Date().getFullYear();

    useEffect(() => {
        const ID = Cookies.get("redirectid") || "";
        setRedirectID(ID);
    }, []);

    useEffect(() => {
        const token = localStorage.getItem('Token') || '';
        setUserLogin(token);
        setChecked(true);
        setCreditCardError(false);
    }, [isAutoship, redirectID]);


    useEffect(() => {
        if (socialPlatformsValue === "Other (please specify below)" || socialPlatformsValue === "Event (please specify below)") {
            methods?.setValue("other_specification", "");
        } else {
            methods?.setValue("other_specification", undefined);
        }
    }, [socialPlatformsValue, methods]);

    return (
        <div className="cart_form">
            {userLogin && <h4>Payment</h4>}
            <div className="main-wrapper-check">
                <div className="section_first">
                    <div className="checkout-payment-logo-wrap">
                        <div className="checkout-payment-logo-text">
                            {!userLogin && (
                                <>
                                    <label>Payment</label>
                                    <p>All transactions are secure and encrypted.</p>
                                </>
                            )}
                        </div>

                        <div className="logo">
                            <img src="/images/SNIP CreditCard.png/" alt="Credit Card Logo" />
                        </div>
                    </div>
                    <div className="form-wrappper">
                        <input
                            type="text"
                            placeholder="Card Holder Name"
                            name="cardHolder"
                            className="form-control"
                            ref={methods?.register({ required: "Please enter your card name." })}
                        />
                        {methods?.errors?.cardHolder && <span className="error">{methods?.errors?.cardHolder?.message}</span>}
                    </div>
                    <div className="form-wrappper">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Card Number"
                            name="cardNumber"
                            ref={methods?.register({
                                required: "Please enter your card number.",
                                pattern: {
                                    value: /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/,
                                    message: "Please Enter Valid card Number"
                                }
                            })}
                        />
                        {methods?.errors?.cardNumber && <span className="error">{methods?.errors?.cardNumber?.message}</span>}
                    </div>
                </div>
                <div className="section_second">
                    <div className="col-md-6 extra">
                        <MonthYear
                            start={1}
                            end={12}
                            name="card_expiry_month"
                            type="MM"
                            label="Exp. Month"
                            validate={{ required: "Enter your expiry month." }}
                            methods={methods}
                        />
                    </div>
                    <div className="col-md-6 extra">
                        <MonthYear
                            start={currentYear}
                            end={2050}
                            name="card_expiry_year"
                            type="YY"
                            label="Exp. Year"
                            validate={{ required: "Enter your expiry Year." }}
                            methods={methods}
                        />
                    </div>
                    <div className="form-wrappper extra">
                        <label>Cvv</label>
                        <input
                            type="text"
                            placeholder="Card CVV"
                            name="cardCVC"
                            className="form-control"
                            ref={methods?.register({
                                required: "Enter CVV.",
                                pattern: {
                                    value: /^[0-9]{3,4}$/,
                                    message: "Enter valid CVV."
                                }
                            })}
                        />
                        {methods?.errors?.cardCVC && <span className="error">{methods?.errors?.cardCVC?.message}</span>}
                    </div>
                </div>

                {!redirectID && (
                    <div className='save-credit-check'>
                        <input
                            type="checkbox"
                            ref={methods?.register}
                            checked={checked}
                            className="form-check-input"
                            id="save_credit_card"
                            name="save_credit_card"
                            onChange={(e) => {
                                if (!isAutoship?.id) {
                                    methods?.setValue('save_credit_card', e.target.checked);
                                    setChecked(e.target.checked);
                                } else {
                                    setCreditCardError(true);
                                }
                            }}
                        /> Save Credit Card
                    </div>
                )}
                {!userLogin &&
                    <>
                        <div className="mb-3 field-class review-checkout">
                            <select
                                className="form-control"
                                name="social_platforms"
                                ref={methods?.register({ required: "This field is required" })}
                            >
                                <option value="">How did you hear about SNiP? Please select one of these options:</option>
                                {SOCIAL_PLATFORMS?.map((row, index) => <option key={index} value={row}>{row}</option>)}
                            </select>
                            {methods?.errors?.social_platforms && <span className="error">{methods?.errors?.social_platforms?.message}</span>}
                        </div>

                        {(socialPlatformsValue === "Other (please specify below)" ||
                            socialPlatformsValue === "Affiliate" ||
                            socialPlatformsValue === "Wellness provider" ||
                            socialPlatformsValue === "Event (please specify below)") && (
                                <div className="form-wrappper review">
                                    <input
                                        type="text"
                                        name="other_specification"
                                        placeholder="Please specify"
                                        className="form-control"
                                        onChange={(e) => setOtherFieldData(e.target.value)}
                                        ref={methods?.register({
                                            required: { value: true, message: "This field is required." }
                                        })}
                                    />
                                    {methods?.errors?.other_specification && (
                                        <span className="error">{methods?.errors?.other_specification?.message}</span>
                                    )}
                                </div>
                            )}
                    </>
                }
                <br />
                <p style={{ color: "red" }}>
                    {creditCardError ? "Saved credit card required for supplement subscription" : ""}
                </p>
            </div>
        </div>
    );
}

export default WithoutLoginCard;
